import React from 'react';
import { CampaignHealthStatusPortal } from './CampaignHealthStatusPortal';
export function CampaignsHealthStatusRenderer(param) {
    var campaignIds = param.campaignIds, _param_portalContainerIdPrefix = param.portalContainerIdPrefix, portalContainerIdPrefix = _param_portalContainerIdPrefix === void 0 ? 'ops' : _param_portalContainerIdPrefix;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, campaignIds.map(function(campaignId) {
        return /*#__PURE__*/ React.createElement(CampaignHealthStatusPortal, {
            key: campaignId,
            campaignId: campaignId,
            portalContainerIdPrefix: portalContainerIdPrefix
        });
    }));
}
